goog.declareModuleId('yext.ui.components.select.native.NativeSelectList');

export function NativeSelectList(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}
